/* eslint-disable react/no-unescaped-entities */
import { Link, useSearchParams } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';
import { useHideEmergentBadge } from '@/hooks/useHideEmergentBadge';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import { getT, resolveLang } from '@/lib/checkoutI18n';
import { useGeoLang } from '@/lib/useGeoLang';

export default function CheckoutCancelled() {
  const [params] = useSearchParams();
  const geoLang = useGeoLang();
  const t = getT(resolveLang(params.get('lang'), geoLang));
  useHideEmergentBadge();
  useDocumentTitle(t.cancelled_overline.replace('— ', ''));
  return (
    <div className="min-h-screen flex items-center justify-center bg-white p-6 fade-in">
      <Card className="card-flat p-10 max-w-lg w-full text-center">
        <div className="w-16 h-16 mx-auto bg-zinc-100 border border-zinc-200 flex items-center justify-center mb-6 rounded-md">
          <XCircle className="h-8 w-8 text-zinc-600" />
        </div>
        <div className="overline mb-2">{t.cancelled_overline}</div>
        <h1 className="font-display text-2xl font-bold mb-3">{t.no_charge}</h1>
        <p className="text-zinc-600">{t.can_retry}</p>
        <Link to="/" className="block mt-8">
          <Button variant="outline" className="rounded-md">{t.back_home}</Button>
        </Link>
      </Card>
    </div>
  );
}
